/* eslint-disable */
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const updateProfile = createAsyncThunk(
  'updateProfile',
  async (params, { rejectWithValue }) => {
    return await axios({
      method: 'post',
      url: `api/profile/${params?.id}`,
      data: params.payload,
      baseURL: process.env.REACT_APP_API_BASE_URL,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);